<template>
    <div :id="loadingPage" class="vs-con-loading__container">
        <new-po-sidebar :name="addSidebar" @refresh="getData()" />
        <po-filter :name="filter" v-model="filters" @search="search" />

        <vs-card class="mb-4">
            <vs-row>
                <vs-col vs-justify="center" vs-align="center" vs-w="12">
                    <po-table :data="data" @add="add" @openFile="openFile" @loadMore="loadMore" @search="search"
                        @openFilter="openFilter" @approve="approve" />
                </vs-col>
            </vs-row>
        </vs-card>
    </div>
</template>

<script>
import PoTable from './components/PoTable.vue'
import NewPoSidebar from './components/NewPoSidebar.vue'
import PoFilter from './components/PoFilter.vue'
import request from './request.js'
import loading from '@/mixins/Loading'
export default {
    components: {
        PoTable,
        NewPoSidebar,
        PoFilter
    },
    data() {
        return {
            data: [],
            filter: 'po-filter',
            addSidebar: 'new-po-sidebar',
            loadingPage: 'po-home-loading',
            lastPage: '1',
            loading: false,
            filters: {
                vendors: [],
                clients: [],
                departaments: [],
                categories: []
            },
            params: {
                search: '',
                page: 1,
            },
        }
    },
    methods: {
        add() {
            this.$store.dispatch('toggleSidebar', this.addSidebar)
        },
        openFilter() {
            this.$store.dispatch('toggleSidebar', this.filter)
        },
        openFile(item) {
            this.item = { id: item.id, name: item.name }
            this.displayModal = true
        },
        getData() {
            this.openLoading(this.loadingPage)
            const payload = {
                search: this.params.search.trim(),
                page: this.params.page,
                vendor_id: this.filters.vendors.length > 0 ? this.filters.vendors.map((el) => el.id) : null,
                client_id: this.filters.clients.length > 0 ? this.filters.clients : null,
                departament_id: this.filters.departaments.length > 0 ? this.filters.departaments : null,
                category_id: this.filters.categories.length > 0 ? this.filters.categories : null,
            }
            request
                .list(payload)
                .then((response) => {
                    if (this.params.page === 1) {
                        this.data = [...response.data.data]
                    } else {
                        this.data = [...this.data, ...response.data.data]
                    }
                    this.lastPage = response.data.last_page
                    this.params.page = response.data.current_page
                    this.closeLoading(this.loadingPage)
                })
                .catch((response) => {
                    this.showValidationErrors(response)
                    this.closeLoading(this.loadingPage)
                })
        },
        loadMore() {
            if (this.params.page >= this.lastPage) {
                return
            }
            this.params.page++
            this.getData()
        },
        search: function (text = '') {
            this.params.search = text
            this.params.page = 1
            this.getData()
        },
        approve(item) {
            this.$vs.notify({
                color: 'success',
                title: 'Success',
                text: 'PO UPDATED'
            });
        }
    },
    mixins: [loading],
    mounted() {
        this.getData()
    },


}
</script>

<style></style>